import { render, staticRenderFns } from "./refundsForWXMall.vue?vue&type=template&id=1463ad41&scoped=true"
import script from "./refundsForWXMall.vue?vue&type=script&lang=js"
export * from "./refundsForWXMall.vue?vue&type=script&lang=js"
import style0 from "./refundsForWXMall.vue?vue&type=style&index=0&id=1463ad41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463ad41",
  null
  
)

export default component.exports